import { createReducer, on } from '@ngrx/store';
import { searchAirports, searchAirportsFailure, searchAirportsSuccess } from './airports-info-service.actions';
import { airportsInfoAdapter, initialAirportsInfoServiceState } from './airports-info-service.state';

export const airportsInfoReducer = createReducer(
  initialAirportsInfoServiceState,
  on(searchAirports, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(searchAirportsSuccess, (state, { id, airports }) => ({
    ...state,
    airports: airportsInfoAdapter.setOne({ id, airports }, state.airports),
    loading: false,
    error: null,
  })),
  on(searchAirportsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
